import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import Thumbnail from "../fileManager/Components/Thumbnail";
import { withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../components/elements/LoadingButton";
import SubTitle from "../../components/elements/SubTitle";
import AppAnimate from "../../components/AppAnimate/index";
import AppCard from "../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import FieldCounter from "../../components/elements/FieldCounter";
import {connect, setStore} from "trim-redux";
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import LinearCategoryHolder from "../../components/fields/LinearCategoryHolder/index";
import ImageGallery from "../fileManager/Components/ImageGallery";


class MakeProduct extends React.Component {

    constructor(props){
        super(props);
        this.ThumbChild = React.createRef();
    }
    state = {
        fields:{
            name:"",
            code:"",
            transfer_type:"",
            description:"",
            text:"",
            howToSell:false,
            shop_id:this.props.user.shops.length ? this.props.user.shops[0].id : '',
            shop_name:'',
            price:'',
            priceR:'',
            discount_price:'',
            discount_priceR:'',
            transfer_price:'',
            transfer_priceR:'',
            target_link:'',
        },
        thumbnail: 1,
        editor_input_text: '',
        errors:{},
        categories:[],
        categoriesName:[],
        variables:[],
        variables_res:[],
        gallery: [],
        avalues: [],
        loading: true,
        loadingVariables: false,
        SubmitLoading: false,
        publish: true,
        confirmed: false,
        slug: null,
        id:this.props.match.params.id,
        editMode:false,
        percent:'',
        has_attribute:false,
    };
    classes = this.props.classes;
    componentDidMount(){
        if(this.state.id){
            this.setState({
                editMode:true
            })
            this.loadData();
        }else{
            this.setState({
                loading:false
            })
        }
    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }
    handleThumbImage(id){
        this.setState({
            thumbnail: id
        })
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/product/get/${this.state.id}`, config)
                .then(response => {
                    this.setState({
                        fields: {
                            name: response.data.name,
                            code: response.data.code,
                            transfer_type: response.data.transfer_type,
                            description: !!response.data.description ? response.data.description : '',
                            text: !!response.data.text ? response.data.text : '',
                            price: response.data.price,
                            priceR: response.data.price,
                            howToSell: response.data.online,
                            shop_id: response.data.shop_id,
                            shop_name: response.data.shop.name,
                            target_link: response.data.target_link,
                            discount_price: response.data.discount_price === null ? "" : response.data.discount_price,
                            discount_priceR: response.data.discount_price === null ? "" : response.data.discount_price,
                            transfer_price: response.data.transfer_price === null ? "" : response.data.transfer_price,
                            transfer_priceR: response.data.transfer_price === null ? "" : response.data.transfer_price,
                        },
                        thumbnail: response.data.thumbnail.id,
                        publish: response.data.publish,
                        confirmed: response.data.confirmed,
                        percent : response.data.discount_price > 0 ? Math.max(0, Math.floor((response.data.price - response.data.discount_price)*100/response.data.price)) : '',
                        variables_res: response.data.variables,
                        slug: response.data.slug,
                        has_attribute: response.data.has_attribute

                    })
                    let categoriesTemp=[];
                    let categoriesNameTemp=[];
                    let galleryTemp=[];
                    let avaluesTemp=[];
                    response.data.categories.map(item => {
                        categoriesTemp.push(item.id)
                        categoriesNameTemp.push(item.name)
                        return true
                    })
                    response.data.gallery.map(item =>{
                        galleryTemp.push({
                            src: `${defaultVariabls.uploads}/FileManager/${item.name}_small.${item.extension}`,
                            id: item.id,
                        })
                        return true
                    })
                    response.data.values.map(item =>{
                        avaluesTemp.push(item.id)
                        return true
                    })
                    this.setState({
                        categories: categoriesTemp,
                        categoriesName: categoriesNameTemp,
                        avalues: avaluesTemp,
                        gallery: galleryTemp,
                        loading: false
                    })
                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    handleChange(e){
        let {errors,fields,percent} = this.state;
        let target = e.target;
        if(target.name === "price"){
            fields.priceR = target.value.replace(/,/ig, '');
            if(!!fields.discount_priceR)
                percent = Math.max(0, Math.floor((fields.priceR - fields.discount_priceR)*100/fields.priceR));

        }else if (target.name === "discount_price") {
            fields.discount_priceR = target.value.replace(/,/ig, '');
            if(!!fields.priceR)
                percent = Math.max(0, Math.floor((fields.priceR - fields.discount_priceR)*100/fields.priceR));
            if(parseInt(fields.discount_priceR) >= parseInt(fields.priceR)){
                fields.discount_price = '';
                fields.discount_priceR = '';
                percent = ''
            }
        }else{
            fields[target.name] = target.value;
        }
        errors[target.name] = "";
        this.setState({
            fields,
            percent

        });
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(validator.isEmpty(fields.name)){
            formIsValid = false;
            errors['name'] = Translate.emptyField;
        }
        //name
        if(validator.isEmpty(fields.code)){
            formIsValid = false;
            errors['code'] = Translate.emptyField;
        }

        //Description
        if(fields.description !== null ) {
            if (fields.description.length > 300) {
                formIsValid = false;
                errors['description'] = Translate.maxLength300;
            }
        }
        //text
        if(fields.text !== null ) {
            if (fields.text.length > 1000) {
                formIsValid = false;
                errors['text'] = Translate.maxLength1000;
            }
        }

        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { id,fields,thumbnail,variables,editMode,gallery,categories,confirmed,has_attribute,avalues} = this.state;
        let data = new FormData();
        data.append('name', fields.name);
        data.append('code', fields.code);
        data.append('target_link', fields.target_link);
        data.append('shop_id', editMode ? fields.shop_id : 1);
        data.append('id', id ? id : 0);
        data.append('description', fields.description);
        data.append('text', fields.text);
        data.append('thumbnail', thumbnail);
        data.append('price', editMode ? fields.priceR : 0);
        data.append('confirmed' , editMode ? confirmed ? 1 : 0 : 1);
        data.append('has_attribute',has_attribute ? 1 : 0);
        data.append('discount_price', editMode ? fields.discount_priceR : 0);
        data.append('for_tracking',1);
        data.append('variables', JSON.stringify(variables));
        data.append('avalues', JSON.stringify(avalues));
        data.append('categories', JSON.stringify(categories));
        if(gallery !== null){
            let galery_ids = [];
            gallery.map((row) =>{
                galery_ids.push(row.id);
                return true
            })
            gallery = JSON.stringify(galery_ids);
        }
        data.append('gallery', gallery);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/product/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(editMode ? Translate.dataEdited : Translate.dataAdded, {
                    variant: 'success',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
                if(!this.state.editMode){
                    this.props.history.push(`/manage/manage-products`);
                }
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(editMode ?  Translate.dataEdited : Translate.dataAddingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    handleSubmit(e,draft = false){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.setState({
                    publish:draft
                })
                this.handleRequest();
            }
        });
    }
    async handleCategoryHolder(categories){
        await this.setState({
            loadingVariables:true
        })
        await this.setState({categories});
        await this.setState({
            loadingVariables:false
        })
    }
    handleVariablesHolder(variables){
        this.setState({variables})
    }
    handleGalleryChange(data){
        this.setState({
            gallery: data,
        })
    }
    handleChangeConfirmed(){
        this.setState({
            confirmed: !this.state.confirmed,
        })
    }
    handleAttributeValues(avalues){
        this.setState({
            avalues
        })
    }
    render(){
        let {fields,percent, errors,gallery,has_attribute,avalues,SubmitLoading,thumbnail,categoriesName,editMode,confirmed,editor_input_text} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={editMode ? Translate.editProduct : Translate.makeProduct}>
            {

                        <Grid container spacing={2} justify="center">
                            <Grid item xs={12} md={8} lg={9}>
                                <Grid container spacing={2} justify="center">
                                    <Grid item xs={12}>
                                        <AppCard
                                            title={editMode ? Translate.editProduct : Translate.makeProduct}
                                            action={
                                                <BreadCrumbs singleLevel firstText={this.props.edit ? Translate.editProduct : Translate.makeProduct}/>
                                            }>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2} justify="center" alignItems="center" style={{marginBottom:10}}>
                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                margin="normal"
                                                                required
                                                                fullWidth
                                                                name="name"
                                                                variant="outlined"
                                                                label={Translate.productName}
                                                                placeholder={Translate.productName}
                                                                type="text"
                                                                id="name"
                                                                value={fields.name}
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['name']}
                                                                helperText={errors['name']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                margin="normal"
                                                                required
                                                                fullWidth
                                                                name="code"
                                                                variant="outlined"
                                                                label={Translate.productCode}
                                                                placeholder={Translate.makeACodeForProduct}
                                                                type="text"
                                                                value={fields.code}
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['code']}
                                                                helperText={errors['code']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                margin="normal"
                                                                required
                                                                fullWidth
                                                                name="target_link"
                                                                variant="outlined"
                                                                label={Translate.target_url_product}
                                                                type="text"
                                                                value={fields.target_link}
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['target_link']}
                                                                helperText={errors['target_link']}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppCard style={{height:"100%"}}>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <LinearCategoryHolder
                                                                outPut={this.handleCategoryHolder.bind(this)}
                                                                inPut={categoriesName} editMode={categoriesName.length === 0 ? false : editMode}/>
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                            this.state.loading ? <AppCardLoaderFields/> :
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <SubTitle align="left">{Translate.productDescription}</SubTitle>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            variant="outlined"
                                                            margin="normal"
                                                            multiline
                                                            fullWidth
                                                            name="description"
                                                            label={Translate.seoDescription}
                                                            placeholder={Translate.seoDescription}
                                                            type="text"
                                                            id="description"
                                                            rows="3"
                                                            value={fields.description}
                                                            onChange={this.handleChange.bind(this)}
                                                            error={!!errors['description']}
                                                            helperText={errors['description']}
                                                        />
                                                        <FieldCounter length={fields.description.length} max={300}/>
                                                    </Grid>
                                                </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <LoadingButton
                                            variant="contained"
                                            color="primary"
                                            onClick = {this.handleSubmit.bind(this)}
                                            loading = {SubmitLoading}
                                        >
                                            {editMode ? Translate.editProduct : Translate.makeProduct}
                                        </LoadingButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <Grid container spacing={2} alignItems="center" justify="center">
                                    <Grid item xs={12} style={{paddingTop: 0}}>
                                        <LoadingButton
                                            variant="contained"
                                            color="primary"
                                            styleForParent={{marginBottom:10}}
                                            style={{width: "100%"}}
                                            onClick={this.handleSubmit.bind(this)}
                                            loading={SubmitLoading}
                                        >
                                            {editMode ? Translate.editProduct : Translate.makeProduct}
                                        </LoadingButton>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12}>
                                                            <SubTitle>{Translate.ThumbnailTitle}</SubTitle>
                                                            <Thumbnail rounded ref={this.ThumbChild}
                                                                       handleThumbImage={this.handleThumbImage.bind(this)}
                                                                       initial={thumbnail}/>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <SubTitle>{Translate.gallery}</SubTitle>
                                                            <ImageGallery onChange={this.handleGalleryChange.bind(this)} initial={gallery}/>
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                }
            </AppAnimate>

        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(MakeProduct))));